
/**
 * Checks if a value is a plain object
 * @param value - The value to check
 * @returns True if the value is a plain object, false otherwise
 */
export const isPlainObject = (value: unknown): boolean => {
    return (
        typeof value === 'object' &&
        value !== null &&
        Object.prototype.toString.call(value) === '[object Object]'
    );
};